module.exports = __webpack_public_path__ + "images/file-7cb3dc3449.svg";